module.exports = __webpack_public_path__ + "static/img/ts_yth_pic.f5be229.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ts_yth_pic.jpg
// module id = YnHR
// module chunks = 1